import { values as objValues, pickBy } from 'lodash-es';

import {
  fromServerDateOptional,
  toServerDateOptional,
} from '../../common/utils/dateUtils';
import { isFormValuePresent } from '../../components/forms/formHelpers';
import { makeSort } from '../common/sort';

export function monitorFiltersFormToGraphQL(formValues, isQuote = false) {
  return {
    dateFrom: toServerDateOptional(formValues?.dateRange?.from),
    dateTo: toServerDateOptional(formValues?.dateRange?.to),
    accountNumber: formValues?.accountNumber,
    originAirport: formValues?.originAirport,
    destinationAirport: formValues?.destinationAirport,
    ...(!isQuote && { shipmentStatus: formValues?.shipmentStatus }),
    ...formValues.shipmentDetails,
  };
}

export function monitorSortFormToGraphQL(sort) {
  if (!sort) {
    return null;
  }
  if (sort.name === 'dateRange') {
    return makeSort('date', sort.order);
  }
  return makeSort(sort.name, sort.order);
}

export function filterTemplateFormToGraphQL(formValues, overwrite) {
  return {
    name: formValues.name,
    overwrite,
    date: formValues?.dateRange && {
      dateFrom: toServerDateOptional(formValues.dateRange.from),
      dateTo: toServerDateOptional(formValues.dateRange.to),
      namedRange: formValues.dateRange.namedRange,
    },
    accountNumber: formValues?.accountNumber,
    shipmentStatus: formValues?.shipmentStatus,
    originAirport: formValues?.originAirport,
    destinationAirport: formValues?.destinationAirport,
    ...formValues.shipmentDetails,
  };
}

export function filterTemplateGraphQLToForm(values, presets) {
  const shipmentDetails = pickBy(
    {
      destinationContactName: values?.destinationContactName,
      destinationCity: values?.destinationCity,
      destinationCountry: values?.destinationCountry,
      shipperName: values?.shipperName,
      shipperCity: values?.shipperCity,
      shipperCountry: values?.shipperCountry,
      costCenter: values?.costCenter,
      shipperReference: values?.shipperReference,
      jobNumber: values?.jobNumber,
    },
    isFormValuePresent
  );
  let dateRange;
  if (values?.date) {
    if (values.date.namedRange) {
      dateRange = {
        namedRange: values.date.namedRange,
        ...presets[values.date.namedRange],
      };
    } else {
      dateRange = {
        from: fromServerDateOptional(values.date.dateFrom),
        to: fromServerDateOptional(values.date.dateTo),
        namedRange: null,
      };
    }
  }
  return {
    id: values.id,
    name: values.name,
    dateRange,
    accountNumber: values?.accountNumber,
    shipmentStatus: values?.shipmentStatus,
    originAirport: values?.originAirport,
    destinationAirport: values?.destinationAirport,
    shipmentDetails:
      objValues(shipmentDetails).length > 0 ? shipmentDetails : null,
  };
}
